const Event = () => {
  return <>Events Page</>;
};

export default Event;
